import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";
import { MainAdminSidebar, MainAdminTop } from "../components";
import "./AdminWorkspace.css";

const LayoutMainAdmin = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const token = new Cookies().get("token");
  if (!token) return <Navigate to="/SignIn" replace />;

  return <div className="admin-shell" dir="rtl">
    <MainAdminSidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
    {menuOpen && <button className="admin-backdrop" aria-label="بستن منو" onClick={() => setMenuOpen(false)} />}
    <section className="admin-main">
      <MainAdminTop onMenu={() => setMenuOpen((value) => !value)} />
      <div className="admin-content"><Outlet /></div>
    </section>
  </div>;
};

export default LayoutMainAdmin;
